// extracted by mini-css-extract-plugin
export default {"invalid-error":"PAndIFranchiseForm_invalid-error__TNKHy"};